import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CategoryList, DownloadModel, ExpenseAndReportModel, FilterModal, StatusListModel, travelIds } from 'src/app/models/Common/common.model';
import { CommonService } from 'src/app/services/common-services/common.service';
import { ExpensesService } from 'src/app/services/expenses.service';
import { PlatformService } from 'src/app/services/platformbase.service';
import { TravelService } from 'src/app/services/travel.service';
import { TranslateService } from '@ngx-translate/core';
import { ChangeContext, LabelType, Options } from 'ng5-slider';
import { Constants } from 'src/app/Constants';
import * as moment from 'moment';
import * as _ from "lodash";
import { NavController } from '@ionic/angular';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-travel',
  templateUrl: './travel.component.html',
  styleUrls: ['./travel.component.scss'],
})
export class TravelComponent implements OnInit {
  @ViewChild("downloadLoader", { static: false }) private downloadLoader;
  showFilter = false;
  fromPettyCash = false;
  dropdownFlag = false;
  showSearch = false;
  draft = true;
  platformType: number;
  loaderList = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  dummyList = [1, 2, 3];
  showLoading: boolean = true;
  userInfo: any;
  travelRequestData: any;
  pageNumber = 1;
  pageSize = 50;
  maxDate: any;
  minDate: any;
  frmDate: any;
  mobMaxDate: any;
  tDate: any;
  statusList = [];
  totalRecords = 0;
  options: any;
  minPrice = 0;
  maxPrice = 0;
  currentday: any;
  hideNewTravelBtn = true;
  travelFormsData: any;
  categoryList: any;
  travelIdsList: any;
  checkAllStatus: any;
  checkAllCat: any;
  checkAllId: any;
  selectedStatus = [];
  selectedcategory = [];
  selectedId = [];
  statusState: boolean;
  categoryState: boolean;
  idState: boolean;
  downloadBtn = false;
  downloadModel = new DownloadModel();
  selectedExpense = [];
  downloadTime: any;
  modalRef: any;


  expenseAndReportModel = new ExpenseAndReportModel();
  filterModal = new FilterModal();
  downloadActionPoolCount = 0;

  constructor(private platformService: PlatformService,
    private travelRequestService: TravelService,
    private toastr: ToastrService, private expenseService: ExpensesService,
    private commonService: CommonService, private translate: TranslateService,
    private navContrl: NavController,private modalService: BsModalService,) { }

  ngOnInit() {

    this.filterModal.statusIds = [];
    this.filterModal.ids = [];
    this.filterModal.forUserIds = [];
    this.filterModal.departmentIds = [];
    this.filterModal.categoryIds = [];
    this.filterModal.recordTypes = [];
    this.filterModal.formTypes = [];
    this.filterModal.isDraft = null;

  }
  ionViewWillEnter() {
    this.platformType = this.platformService.getPlatformType();
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    if ((this.userInfo.roleId == 2 || this.userInfo.roleId == 3) && JSON.parse(sessionStorage.getItem('isadmin'))) {
      this.hideNewTravelBtn = false;
    }
    this.currentday = moment(new Date()).format(Constants.mobileCalenderFormat);
    this.getStatusList();
    this.getTravelFormIdsList();
    this.getTravelFormsList();
    this.getTravelRequestList(true);
  }

  getTravelRequestList(isPageLoad, event?) {
    this.expenseAndReportModel.isAdminView = JSON.parse(sessionStorage.getItem('isadmin'));
    if ((JSON.parse(sessionStorage.getItem('isadmin')) == true) && (this.userInfo.roleId == 2)) {
      this.expenseAndReportModel.viewType = this.userInfo.roleId;
    } else {
      this.expenseAndReportModel.viewType = 1;
    }
    this.expenseAndReportModel.legalEntityId = this.userInfo.legalEntityId;
    this.expenseAndReportModel.legalEntityGUID = this.userInfo.legalEntityGuId;
    this.expenseAndReportModel.userId = this.userInfo.userId;
    this.expenseAndReportModel.userGUID = this.userInfo.userGuId;
    this.expenseAndReportModel.pageNumber = this.pageNumber;
    this.expenseAndReportModel.filterBy = this.filterModal;
    this.expenseAndReportModel.filterBy.isDraft = this.platformType === 2 ? this.draft : null;
    this.expenseAndReportModel.pageSize = this.pageSize;
    this.expenseAndReportModel.recordType = this.fromPettyCash ? 4 : 6;
    this.expenseAndReportModel.filterBy.statusIds = this.expenseAndReportModel.filterBy.statusIds[0] ? this.expenseAndReportModel.filterBy.statusIds : [];
    console.log("model class :", this.expenseAndReportModel);
    this.changeOptions(
      1000,
      2000
    );
    this.expenseService.getExpenseList(this.expenseAndReportModel)
      .subscribe((res) => {
        this.showLoading = false;
        if (!res.isError && res.errorCode == 0) {
          this.travelRequestData = res.payload.expenseResponseList;
          this.totalRecords = res.payload.expenseResponseList.length;
          this.selectedStatus = [];
          this.selectedcategory = [];
          this.selectedId = [];

        } else {

        }
      });
  }

  getTravelFormsList() {
    let modal = {
      legalEntityId: this.userInfo.legalEntityId,
      legalEntityGUID: this.userInfo.legalEntityGuId
    }
    this.travelRequestService.travelFormsList(modal).subscribe((res) => {
      if (!res.isError && res.errorCode == 0) {
        this.travelFormsData = res.payload;
        const listarray = res.payload;
        this.categoryList = listarray.map((list) => new CategoryList(list));
        console.log("sdsds", this.categoryList);
      } else {

      }
    });
  }

  getTravelFormIdsList() {
    let modal = {
      legalEntityId: this.userInfo.legalEntityId,
      legalEntityGUID: this.userInfo.legalEntityGuId
    }
    this.travelRequestService.travelFormIdsList(modal).subscribe((res) => {
      if (!res.isError && res.errorCode == 0) {
        this.travelFormsData = res.payload;
        const listarray = res.payload;
        this.travelIdsList = listarray.map((list) => new travelIds(list));
      }
    });
  }

  bulkDownload(list?) {
    const config = {
      ignoreBackdropClick: true,
      class: "modal-md modal-dialog-centered",
      keyboard: false,
    };
    this.modalRef = this.modalService.show(this.downloadLoader, config);
    console.log("doanloead click", this.userInfo);
    this.downloadBtn = true;
    // if (this.travelRequestData.length) {
    //     this.downloadModel.referenceIds = this.selectedExpense.toString();
    // } else {
    //     this.downloadModel.referenceIds = null;
    // }
    if (list) {
      this.downloadModel.referenceIds = list.expenseId;
      this.downloadBtn = false;
    }
    this.downloadModel.recordType = 6;
    this.downloadModel.referenceIds = null;
    this.filterModal.isDraft = null;
    this.downloadModel.filterBy = this.filterModal;
    this.downloadModel.userId = this.userInfo.userId;
    this.downloadModel.userGUID = this.userInfo.userGuId;
    this.downloadModel.entityType = 1;
    this.downloadModel.isAdminView = JSON.parse(sessionStorage.getItem('isadmin'));
    this.downloadModel.legalEntityId = this.userInfo.legalEntityId;
    this.downloadModel.legalEntityGUID = this.userInfo.legalEntityGuId;
   // this.downloadModel.viewType = this.userInfo.roleId;
    this.downloadModel.viewType = this.expenseAndReportModel.viewType;

    this.downloadModel.isApprover = false;
    this.commonService.downloadList(this.downloadModel).subscribe(res => {
      if (!res.error && res.payload) {
        this.downloadPoolingStart(res.payload, 3000);
      }
    });
  }
  downloadCancel() {
    this.modalRef.hide();
  }
  downloadPoolingStart(request, time) {
    this.downloadActionPoolCount++;
    this.downloadModel.jobId = request.jobId;
    this.downloadModel.jobGUID = request.jobGUID;
    this.commonService.downloadpoolStart(this.downloadModel).subscribe(res => {
      if (!res.isError && res.payload.status == (1 || 2) && this.downloadActionPoolCount < 30) {

        this.downloadTime = setTimeout(() => {
          this.downloadPoolingStart(res.payload, time);
        }, time);
      } else if (!res.isError && res.payload.status == 3) {
        this.downloadBtn = false;
        window.open(res['payload']['resultFileURL'], '_self');
        this.toastr.success(this.translate.instant('alerts.downloadsucces'), this.translate.instant('alerts.succes'));
        this.downloadActionPoolCount = 0;
        this.modalRef.hide();
      } else {
        this.toastr.error(res.errorMessage, this.translate.instant('alerts.error'));
        this.downloadBtn = false;
        this.downloadActionPoolCount = 0;
        this.modalRef.hide();
      }
    });
  }

  getStatusList() {
    const type = { type: +1 };
    this.commonService.statusList(type).subscribe((res) => {
      if (!res.isError && res.errorCode === 0) {
        const listarray = res.payload;
        this.statusList = listarray.map((list) => new StatusListModel(list));
        // if (this.fromAnlyticsPage) {
        //     this.statusList.filter(res => {
        //         if (res.statusId == this.fromAnlyticsPage) {
        //             res.isSelected = true;
        //         }

        //     });
        // }
      } else if (res.isError === true) {
        this.toastr.error(res.errorMessage, this.translate.instant('alerts.error'));
      }
    });
  }

  searchbar() {
    this.showSearch = !this.showSearch;
  }
  showFiltersection() {
    this.showFilter = !this.showFilter;
  }

  changeOptions(minValue, maxValue) {
    const newOptions: Options = Object.assign({}, this.options);
    newOptions.floor = minValue;
    newOptions.ceil = maxValue;
    this.minPrice = minValue;
    this.maxPrice = maxValue;
    this.options = newOptions;
  }
  priceSlider(changeContext: ChangeContext) {
    this.filterModal.minPrice = changeContext.value;
    this.filterModal.maxPrice = changeContext.highValue;
  }

  resetDates() {
    this.frmDate = undefined;
    this.tDate = undefined;
    this.filterModal.fromDate = undefined;
    this.filterModal.toDate = undefined;
    this.minDate = undefined;
    this.maxDate = new Date();
  }

  resetFilters(list) {
    list.forEach((item) => {
      item.isSelected = false;
    });
  }
  selectAllStatus() {
    setTimeout(() => {
      this.statusList.forEach((item) => {
        item.isSelected = this.checkAllStatus;
      });
    });
  }

  selectAllCategory() {
    setTimeout(() => {
      this.categoryList.forEach((item) => {
        item.isSelected = this.checkAllCat;
      });
    });
  }

  selectAllIds() {
    setTimeout(() => {
      this.travelIdsList.forEach((item) => {
        item.isSelected = this.checkAllId;
      });
    });
  }

  selectSingleStatus(list) {
    if (list.isSelected) {
      this.selectedStatus.push(list.statusId);
      this.filterModal.statusIds = this.selectedStatus;
    } else {
      const index = _.indexOf(this.selectedStatus, list.statusId);
      this.selectedStatus.splice(index, 1);
      this.filterModal.statusIds = this.selectedStatus;
    }
    this.filterModal.statusIds = this.selectedStatus;
    if (
      this.statusList.length !== this.selectedStatus.length &&
      this.selectedStatus.length > 0
    ) {
      this.checkAllStatus = false;
      this.statusState = true;
    } else if (this.selectedStatus.length === 0) {
      this.checkAllStatus = false;
      this.statusState = false;
    } else {
      this.checkAllStatus = true;
      this.statusState = false;
    }
  }

  selectSingleCategory(list) {
    if (list.isSelected) {
      this.selectedcategory.push(list.id);
    } else {
      const index = _.indexOf(this.selectedcategory, list.id);
      this.selectedcategory.splice(index, 1);
    }
    this.filterModal.formTypes = this.selectedcategory;
    if (
      this.categoryList.length !== this.selectedcategory.length &&
      this.selectedcategory.length > 0
    ) {
      this.checkAllCat = false;
      this.categoryState = true;
    } else if (this.selectedcategory.length === 0) {
      this.checkAllCat = false;
      this.categoryState = false;
    } else {
      this.checkAllCat = true;
      this.categoryState = false;
    }

  }

  selectSingleId(list) {
    if (list.isSelected) {
      this.selectedId.push(list.id);
    } else {
      const index = _.indexOf(this.selectedId, list.id);
      this.selectedId.splice(index, 1);
    }
    this.filterModal.ids = this.selectedId;
    if (this.travelIdsList.length !== this.selectedId.length && this.selectedId.length > 0) {
      this.checkAllId = false;
      this.idState = true;
    } else if (this.selectedId.length === 0) {
      this.checkAllId = false;
      this.idState = false;
    } else {
      this.checkAllId = true;
      this.idState = false;
    }

  }

  applyfilter() {
    this.showFilter = false;
    //this.resetPaging();
    if (this.frmDate !== undefined && this.tDate === undefined) {
      this.tDate = this.mobMaxDate;
      this.filterModal.toDate = moment(new Date()).format(Constants.mobileDateFormat);
    }
    if (this.frmDate === undefined && this.tDate !== "") {
      this.frmDate = this.tDate;
      this.filterModal.fromDate = this.tDate;
    }
    // this.createFilters();
    this.filterModal.fromDate = this.frmDate ? moment(new Date(this.frmDate)).format(Constants.mobileDateFormat) : undefined;
    this.filterModal.toDate = this.tDate ? moment(new Date(this.tDate)).format(Constants.mobileDateFormat) : undefined;

    this.showLoading = true;
    this.getTravelRequestList(false);
    //this.returnExpSegment();
  }

  goToNewForm(root: any) {
    let navInfo = {
      url: 'travel'
    };
    sessionStorage.setItem('toPathInfo', JSON.stringify(navInfo));
    this.navContrl.navigateRoot([root]);
  }
  /*detailView */
  showDetailreport = false;
  detailReport: any;
  expensesList = [];

  showReportDetail(list) {
    this.detailReport = list;
    this.showDetailreport = true;
    let res = { "errorMessage": null, "errorCode": 0, "payload": { "reportsCount": 3, "reportMinAmount": 200.00, "reportMaxAmount": 12764.00, "isReportCreated": true, "isApprovalExist": false, "reportResponseList": [{ "claimId": 2858, "claimGUID": "6b53dce05a5374d61b8c911a6c655d66", "claimCode": "REP002858", "claimName": "hellotest", "tripId": null, "tripName": null, "tripStartDate": null, "tripEndDate": null, "poolId": null, "poolGUID": null, "dynamoId": null, "dynamoGUID": null, "isLinkedToAdvancePayment": false, "advancePaymentId": "", "legalEntityId": 271, "legalEntityGUID": "7b71c0b7fb49702052aa309125f8b148", "status": 1, "statusDescription": "Draft", "createdDate": "31-01-2022", "updatedDate": "31-01-2022", "userId": 269, "userFirstName": "Jahed", "userLastName": "Admin", "employeeId": "EMPID0001", "approverId": null, "approverFirstName": null, "approverLastName": null, "approverTypeName": null, "userGUID": "5c0c98f5bc1926221dd9364e3f247998", "noOfExpenses": "0", "baseCurrencyId": null, "baseCurrencyCode": null, "baseCurrencyIcon": null, "totalBaseAmount": "0", "submittedDate": null, "paymentStatus": null, "paidDate": null, "expenseIds": [], "recordType": 1, "advanceAmount": "0.00", "unformattedAdvanceAmount": null, "approvedAmount": "0", "unformattedApprovedAmount": null, "advanceAppliedAmount": null, "reason": null, "isLinkedToPettyCashPayment": false, "pettyCashAmount": "0.00", "unformattedPettyCashAmount": null, "hasViolation": null, "violationList": null, "expenseList": null, "reportHistoryList": null, "reportPaymentDetails": null }, { "claimId": 2789, "claimGUID": "53de9bb8447646173f2f11efaf8c180e", "claimCode": "REP002789", "claimName": "demoone", "tripId": null, "tripName": null, "tripStartDate": null, "tripEndDate": null, "poolId": null, "poolGUID": null, "dynamoId": null, "dynamoGUID": null, "isLinkedToAdvancePayment": false, "advancePaymentId": "", "legalEntityId": 271, "legalEntityGUID": "7b71c0b7fb49702052aa309125f8b148", "status": 2, "statusDescription": "Awaiting Approval", "createdDate": "28-01-2022", "updatedDate": "28-01-2022", "userId": 269, "userFirstName": "Jahed", "userLastName": "Admin", "employeeId": "EMPID0001", "approverId": 268, "approverFirstName": "Jahed", "approverLastName": "Manager", "approverTypeName": null, "userGUID": "5c0c98f5bc1926221dd9364e3f247998", "noOfExpenses": "3", "baseCurrencyId": 64, "baseCurrencyCode": "INR", "baseCurrencyIcon": "fa-inr", "totalBaseAmount": "2,105", "submittedDate": "28-01-2022", "paymentStatus": null, "paidDate": null, "expenseIds": [4788, 4789, 4790], "recordType": 1, "advanceAmount": "0.00", "unformattedAdvanceAmount": null, "approvedAmount": "1,102", "unformattedApprovedAmount": null, "advanceAppliedAmount": null, "reason": null, "isLinkedToPettyCashPayment": false, "pettyCashAmount": "0.00", "unformattedPettyCashAmount": null, "hasViolation": false, "violationList": null, "expenseList": null, "reportHistoryList": null, "reportPaymentDetails": null }, { "claimId": 2778, "claimGUID": "72aef168c00e6dc786722a401e7a494b", "claimCode": "REP002778", "claimName": "test", "tripId": null, "tripName": null, "tripStartDate": null, "tripEndDate": null, "poolId": null, "poolGUID": null, "dynamoId": null, "dynamoGUID": null, "isLinkedToAdvancePayment": false, "advancePaymentId": "", "legalEntityId": 271, "legalEntityGUID": "7b71c0b7fb49702052aa309125f8b148", "status": 1, "statusDescription": "Draft", "createdDate": "27-01-2022", "updatedDate": null, "userId": 269, "userFirstName": "Jahed", "userLastName": "Admin", "employeeId": "EMPID0001", "approverId": null, "approverFirstName": null, "approverLastName": null, "approverTypeName": null, "userGUID": "5c0c98f5bc1926221dd9364e3f247998", "noOfExpenses": "1", "baseCurrencyId": 64, "baseCurrencyCode": "INR", "baseCurrencyIcon": "fa-inr", "totalBaseAmount": "200", "submittedDate": null, "paymentStatus": null, "paidDate": null, "expenseIds": [4772], "recordType": 1, "advanceAmount": "0.00", "unformattedAdvanceAmount": null, "approvedAmount": "0", "unformattedApprovedAmount": null, "advanceAppliedAmount": null, "reason": null, "isLinkedToPettyCashPayment": false, "pettyCashAmount": "0.00", "unformattedPettyCashAmount": null, "hasViolation": false, "violationList": null, "expenseList": null, "reportHistoryList": null, "reportPaymentDetails": null }] }, "isError": false };
    const listarray = res.payload.reportResponseList;
    this.expensesList = this.travelRequestData;
  }

  backToapproval() {
    this.showDetailreport = false;
  }

  /*detailView */

}
